<div class="view-order">
  <div class="header-wrapper d-flex justify-content-between align-item">
      <span class="info-text nunito">Information About Request</span>
      <i class="material-icons cursor-pointer" mat-dialog-close>clear</i>
  </div>
  <div class="modal-body-content">
    <div class="order-request nunito">
        <strong class="request-heading font-14">Additional Request :</strong>
        <span class="request-data font-14">{{this.message?.length > 0?this.message:'N/A'}}</span>    
    </div>
    <div class="order-request nunito">
        <strong class="request-heading font-14">{{ "room_number" | translate }} :</strong>
        <span class="request-data font-14">{{ selectedMessage.roomNumber? selectedMessage.roomNumber: "NA"}}</span>
    </div>
    <div class="order-request nunito">
        <strong class="request-heading font-14">{{ "Requested on" | translate }} :</strong>
        <span class="request-data font-14">{{  moment(selectedMessage.CreatedAt).format("DD MMM, YYYY hh:mm A")}}</span>
    </div>
    <ng-container *ngIf="selectedMessage.RequestType === 'service'">
        <div class="order-request nunito">
          <strong class="request-heading font-14"> Service Date   :</strong>
          <span class="request-data font-14">
            {{
              selectedMessage.ServiceDateFrom
                ? moment(selectedMessage.ServiceDateFrom).format('DD MMM, YYYY')
                : 'N/A'
            }}
            to
            {{
              selectedMessage.ServiceDateTo
                ? moment(selectedMessage.ServiceDateTo).format('DD MMM, YYYY')
                : 'N/A'
            }}
          </span>
        </div>
  
        <div class="order-request nunito">
          <strong class="request-heading font-14">{{ 'Service Time ' | translate }} :</strong>
          <span class="request-data font-14">
            {{
              selectedMessage.ServiceTimeFrom
                ? moment(selectedMessage.ServiceTimeFrom).format('hh:mm A')
                : 'N/A'
            }}
            to
            {{
              selectedMessage.ServiceTimeTo
                ? moment(selectedMessage.ServiceTimeTo).format('hh:mm A')
                : 'N/A'
            }}
          </span>
        </div>
    </ng-container>      
    <div class="order-table">
  
        <table>
            <tr>
                <th>Item</th>
                <th>Qty.</th>
            </tr>
            <tr *ngFor="let item of this.cartItems">
                <td>{{item.Name}}</td>
                <td>{{item.Quantity}}</td>
            </tr>
        </table>
  
    </div>
  </div>
</div>